import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { userLoginReducer } from "../reducer/userLoginReducer";
import { userOrdersReducer } from "../reducer/orderReducer";
import { backOfficeReducer } from "../reducer/backOfficeReducer";
import { backOfficeAuthReducer } from "../reducer/backOfficeAuthReducer";
import {registeredUserReducer} from "../reducer/registeredUserReducer";

const reducer = combineReducers({
  loginDetails: userLoginReducer,
  orderResults: userOrdersReducer,
  backOfficeState: backOfficeReducer,
  backofficeAuthState: backOfficeAuthReducer,
  registeredUserDetails: registeredUserReducer,
});

const middleware = [thunk];

const store = createStore(
  reducer,
  /* initial state handled by each reducer, */
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
